import {gql} from '@apollo/client';

const BillingProfileForPlan = gql`
    fragment BillingProfileForPlan on BillingProfile {
        isDeleted
        billingProfileId
        title
        attendanceSchedule {
            id
            fullYear
            title
        }
        billingScheme {
            id
            title
        }
        fundingTypes {
            id
            title
            ... on FundingPlan {
                periods {
                    from
                    to
                    rates {
                        rate
                    }
                }
            }
        }
        annualization {
            invoices
            weeksOfCare
        }
    }
`;

export const GetBillingProfilesForPlan = gql`
    query GetBillingProfilesForPlan($institutionId: InstitutionSetId!, $billingProfileIds: [BillingProfileId!]) {
        finance {
            billingProfiles {
                list(institutionSetId: $institutionId) {
                    ...BillingProfileForPlan
                }
            }
            oldBillingProfiles: billingProfiles {
                list(billingProfileId: $billingProfileIds) {
                    ...BillingProfileForPlan
                }
            }
        }
    }
    ${BillingProfileForPlan}
`;
